import { useEffect, useState } from 'react';
import { Button } from '@/components/ui-kit/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui-kit/dialog';
import { Input } from '@/components/ui-kit/input';
import { Label } from '@/components/ui-kit/label';

type SaveTemplateModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isSaving?: boolean;
  mode?: 'create' | 'update';
  initialName?: string;
  onConfirm: (values: { name: string }) => void;
};

export const SaveTemplateModal = ({
  open,
  onOpenChange,
  isSaving = false,
  mode = 'create',
  initialName = '',
  onConfirm,
}: SaveTemplateModalProps) => {
  const [name, setName] = useState('');
  const isUpdate = mode === 'update';

  useEffect(() => {
    if (!open) return;
    setName(initialName.trim());
  }, [open, initialName]);

  const handleConfirm = () => {
    const trimmedName = name.trim();
    if (!trimmedName) return;
    onConfirm({ name: trimmedName });
  };

  const isValid = name.trim().length > 0;
  const isBusy = isSaving;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{isUpdate ? 'Update template' : 'Save as template'}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="template-name">Template name</Label>
            <Input
              id="template-name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder="Enter template name"
              maxLength={200}
              disabled={isBusy}
            />
          </div>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isBusy}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="bg-[#0161AB] hover:bg-[#01558F] text-white"
            onClick={handleConfirm}
            disabled={!isValid || isBusy}
          >
            {isSaving
              ? isUpdate
                ? 'Updating...'
                : 'Saving...'
              : isUpdate
                ? 'Update template'
                : 'Save template'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
